// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zHhS","title":"Info_title__3xJht","links":"Info_links__pCgls","link":"Info_link__EvoMN","logo":"Info_logo__TCCEb"};